// icons
import { Mail, MessageSquare, PhoneCall } from 'lucide-react';
// utils
import { cn } from '@/utils';
import type { TChannel } from '@/types/common.ts';

interface ChannelProps {
    channel: TChannel;
    className?: string;
}

const ChannelByIntegrationIdn = ({ className, channel }: ChannelProps) => {
    const channelClassName = cn('flex items-center gap-1', className);

    switch (channel) {
        case 'sms': {
            return (
                <div className={channelClassName}>
                    <Mail /> SMS
                </div>
            );
        }
        case 'phone': {
            return (
                <div className={channelClassName}>
                    <PhoneCall /> Phone
                </div>
            );
        }
        case 'chat': {
            return (
                <div className={channelClassName}>
                    <MessageSquare /> Chat
                </div>
            );
        }
        default: {
            return;
        }
    }
};

export default ChannelByIntegrationIdn;
